export const pluralize = (string, count) => {
	return `${string}${1 < count || 0 === count ? 's' : ''}`;
};

export const capitalize = (string) => {
	if ('string' !== typeof string) return '';
	return string.charAt(0).toUpperCase() + string.slice(1);
};
